<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row justify-content-end">
                <div class="col-auto pt-2">
                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                </div>
                <div class="col-auto">
                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <table v-if="filterObj.summaryType == 'customer'" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody v-for="(items, i, j) in creditItems" :key="j">
                            <tr class="dtrg-group dtrg-start dtrg-level-0">
                                <td colspan="9" class="text-capitalize">
                                    <span class="text-secondary mr-2"><i class="fas fa-user"></i></span>{{items[0].memberDisplayName}}
                                </td>
                            </tr>
                            <tr v-for="(item, k) in items" :key="k">
                                <td class="align-middle">{{k+startPage}}</td>
                                <td class="align-middle">{{convertTimestampToDateTime(item.createDate)}}</td>
                                <td class="align-middle">{{item.orderID == "" ? "-" : item.orderID}}</td>
                                <td class="align-middle">{{item.memberDisplayName}}</td>
                                <td class="align-middle">{{item.mobile}}</td>
                                <td class="align-middle">
                                    <span class="badge" :class="getAction(item.amount)== 1 ? 'badge-primary' : 'badge-warning'">{{getAction(item.amount)== 1 ? $t('salon_report.outstandings.outstandings') : $t('salon_report.outstandings.collection')}}</span>
                                </td>
                                <td class="align-middle">{{formatPrice(item.amount)}}</td>
                                <td class="align-middle">{{formatPrice(item.finalAmount)}}</td>
                                <td class="align-middle">{{getOutletName(item.outletID)}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-else class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, k) in creditItems" :key="k">
                                <td class="align-middle">{{k+startPage}}</td>
                                <td class="align-middle">{{convertTimestampToDateTime(item.createDate)}}</td>
                                <td class="align-middle">{{item.orderID == "" ? "-" : item.orderID}}</td>
                                <td class="align-middle">{{item.memberDisplayName}}</td>
                                <td class="align-middle">{{item.mobile}}</td>
                                <td class="align-middle">
                                     <span class="badge" :class="getAction(item.amount)== 1 ? 'badge-primary' : 'badge-warning'">{{getAction(item.amount)== 1 ? $t('salon_report.outstandings.outstandings') : $t('salon_report.outstandings.collection')}}</span>
                                </td>
                                <td class="align-middle">{{formatPrice(item.amount)}}</td>
                                <td class="align-middle">{{formatPrice(item.finalAmount)}}</td>
                                <td class="align-middle">{{getOutletName(item.outletID)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import {handleSessionExpired, setReturnData, getOutletName} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
export default {
    name: "outstandingsList",
    data(){
        return{
            isSpinnerShow: false,
            filterObj: {},
            outlet: [],
            creditItems: {},
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportData: []
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "date", label: this.$i18n.t('table.header.date')},
                {key: "orderID", label: this.$i18n.t('table.header.order_id')},
                {key: "name", label: this.$i18n.t('table.header.name')},
                {key: "mobile", label: this.$i18n.t('table.header.contact')},
                {key: "action", label: ""},
                {key: "amount", label: this.$i18n.t('table.header.amount')},
                {key: "balance", label: this.$i18n.t('table.header.balance')},
                {key: "outlet", label: this.$i18n.t('table.header.outlet')},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.order_id')).toUpperCase()] = "orderID"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.action')).toUpperCase()] = "action"
            ret[(this.$i18n.t('table.header.amount')).toUpperCase()] = "amount"
            ret[(this.$i18n.t('table.header.balance')).toUpperCase()] = "balance"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            if(this.$parent.selectedTab == 'list'){
                this.setExportData(this.exportData)
            }
        }
    },
    methods:{
        convertTimestampToDateTime(date){
            return moment.unix(date).format(this.$msg.CST.DATE_TIME_24)
        },
        formatPrice(price){
            return formatPrice(price)
        },
        getAction(amount){
            return Math.sign(amount)
        },
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        async getCreditList(filterObj){
            let $vm = this;
            this.filterObj = filterObj;
            var dateFilter = "?startCreateDate=" + moment(filterObj.date.startDate).unix() + "&endCreateDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outletID == "all" ? "" : "&outletID=" + filterObj.outletID;
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search
            var typeFilter = filterObj.listType == "all" ? "" : "&" + filterObj.listType + "=1"

            let QUERY_STRING = dateFilter + "&page=" + $vm.page + outletFilter + typeFilter +  searchFilter 
            const url =  this.$api.REPORT_OUTSTANDINGS + QUERY_STRING;

            $vm.isSpinnerShow = true;
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = setReturnData(response.data.result, response.data.count, $vm.page)
                $vm.creditItems = filterObj.summaryType == 'customer' ? $vm.groupItemsByMemberID(result.result) : result.result;
                $vm.totalEntries = response.data.count;
                $vm.totalPage = result.totalPage;

                $vm.startPage = result.startPage;
                $vm.endPage = result.endPage;
                $vm.isSpinnerShow = false;
                
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            await this.getExportData(dateFilter + outletFilter + typeFilter +  searchFilter)
        },
        groupItemsByMemberID(result){
            var group =  _.groupBy(result, 'memberID')
            return group;
        },
        async getExportData(strFilter){
            let $vm = this;
            const url =  this.$api.REPORT_OUTSTANDINGS + strFilter;

            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.exportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_outstandings`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[1].text + ")" + " " + strDate
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_outstandings`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (this.filterObj.outletID == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : this.getOutletName(this.filterObj.outletID)),
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    date: this.convertTimestampToDateTime(data[i].createDate),
                    orderID: data[i].orderID == "" ? "-" : data[i].orderID,
                    name: data[i].memberDisplayName,
                    mobile: data[i].mobile,
                    action: this.getAction(data[i].amount) == 1 ? this.$i18n.t('salon_report.outstandings.outstandings') : this.$i18n.t('salon_report.outstandings.collection'),
                    amount: data[i].amount,
                    balance: data[i].finalAmount,
                    outlet: this.getOutletName(data[i].outletID)
                })
            }

            var exportObj = {
                data: exportData,
                fields: this.exportFields,
                headers: exportHeaders,
                fileName: exportFileName
            }
            
            this.$emit('setExportData', exportObj)
        },
        async handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                await this.getCreditList(this.filterObj);
            }
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
   }
}
</script>
